import { graphql } from '@generated/gql';

export const FETCH_HOME_PAGE_CONFIGURATION_NAME = graphql(/** GraphQL */ `
  query homePageConfigurationBreadcrumbFetchHomePageConfigurationName(
    $homePageConfigurationId: ObjectID!
  ) {
    fetchHomePageConfiguration(
      homePageConfigurationId: $homePageConfigurationId
    ) {
      homePageConfiguration {
        translatedName {
          ...OrganizationTranslatedString
        }
      }
    }
  }
`);
